import FilesSettingsFormContainer from './FilesSettingsFormContainer';

export default FilesSettingsFormContainer;
